import { Injectable } from '@angular/core';
import { FacetValueModel } from '../models/facet-value-model';
import { TreeNode } from 'primeng/api';

@Injectable({
  providedIn: 'root'
})
export class DateFacetService {

  constructor() { }

  monthLookUp = [
    { name: "01", display: "01 (Jan)" },
    { name: "02", display: "02 (Feb)" },
    { name: "03", display: "03 (Mar)" },
    { name: "04", display: "04 (Apr)" },
    { name: "05", display: "05 (May)" },
    { name: "06", display: "06 (Jun)" },
    { name: "07", display: "07 (Jul)" },
    { name: "08", display: "08 (Aug)" },
    { name: "09", display: "09 (Sep)" },
    { name: "10", display: "10 (Oct)" },
    { name: "11", display: "11 (Nov)" },
    { name: "12", display: "12 (Dec)" }
  ];

  getMonthDisplayLabel(m: string) {
    let display = this.monthLookUp.find((k) => k.name == m);
    if (display)
      return display.display;
    else
      return m;
  }

  parseFacetToTree(fieldName: string, facet?: FacetValueModel[]): TreeNode[] {
    let nodes: TreeNode[] = [];

    var items = this.generateDateArr(fieldName, facet);

    nodes = Object.keys(items).reduce((resulty: any[], y) => {
      if (y !== 'key' && y !== 'data' && y !== 'query' && y !== 'count' && y !== 'display') {
        resulty.push({
          data: items[y].query,
          label: items[y].display,
          key: items[y].key,
          children: Object.keys(items[y]).reduce((result: any[], m) => {
            if (m !== 'key' && m !== 'data' && m !== 'query' && m !== 'count' && m !== 'display') {
              result.push({
                data: items[y][m].query,
                label: items[y][m].display,
                key: items[y][m].key,
                children: Object.keys(items[y][m]).reduce((resultDays: any[], d) => {
                  if (d !== 'key' && d !== 'data' && d !== 'query' && d !== 'count' && d !== 'display') {
                    resultDays.push({
                      data: items[y][m][d].query,
                      label: items[y][m][d].display,
                      key: items[y][m][d].key,
                    });
                  }

                  return resultDays.sort(this.compare);
                }, [])
              })
            }
            return result.sort(this.compare);
          }, [])
        })
      }
      return resulty.sort(this.compare);
    }, []);
    return nodes;
  }

  compare(a: any, b: any) {
    if (a.label > b.label) {
      return -1;
    }
    if (a.label < b.label) {
      return 1;
    }
    return 0;
  }

  generateDateArr(fieldName: string, facet?: FacetValueModel[]) {
    var items: any = {};

    if (facet) {
      facet.forEach((f) => {
        var y = f.value.slice(0, 4);
        var m = f.value.slice(5, 7);
        var d = f.value.slice(8, 10);

        if (!items[y]) {
          items[y] =
          {
            key: y,
            display: y,
            query: "(" + fieldName + " ge '" + y + "-01-01'" + " and " + fieldName + " le '" + y + "-12-31')",
            data: f.value,
            count: f.count,
          }
        }

        if (!items[y][m]) {
          items[y][m] = {
            key: y + "-" + m,
            display: this.getMonthDisplayLabel(m),
            query: "(" + fieldName + " ge '" + y + "-" + m + "-01'" + " and " + fieldName + " le '" + y + "-" + m + "-31')",
            data: f.value,
            count: f.count,
          }
        }

        if (!items[y][m][d]) {
          items[y][m][d] = {
            key: y + "-" + m + "-" + d,
            display: d,
            query: "(" + fieldName + " eq '" + y + "-" + m + "-" + d + "')",
            data: f.value,
            count: 0,
          }
        }
      });
    }

    return items;
  }
}
